import { useEffect, useState } from "react";

export default function SportFilter({
    sportsSideBarAll,
    selectedCheckbox,
    onChange,
    loading,
}) {
    const [openAccordionIndex, setOpenAccordionIndex] = useState(null);
    const normalize = (str) =>
        str?.toLowerCase().replace(/[^\w]/g, "").trim();

    /* 🔥 AUTO OPEN ACCORDION WHEN FILTER CHANGES */
   useEffect(() => {
  if (!selectedCheckbox || !sportsSideBarAll) return;

  const normalize = (str) =>
    str?.toLowerCase().replace(/[^\w]/g, "");

  const entries = Object.entries(sportsSideBarAll);

  const foundIndex = entries.findIndex(([cat]) =>
    normalize(cat) === normalize(selectedCheckbox)
  );

  console.log("Accordion open index:", foundIndex);

  if (foundIndex !== -1) {
    setOpenAccordionIndex(foundIndex);
  }
}, [selectedCheckbox, sportsSideBarAll]);




    const onReset = () => {
        onChange("");
        setOpenAccordionIndex(null);
    };

    return (
        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
            <div className="filter-resturante">
                {/* Header */}
                <div className="filter-header d-flex justify-content-between align-items-center">
                    <h3>Filter Sports</h3>
                    <button onClick={onReset} className="refresh-icon border-0">
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>

                {/* Accordion */}
                <div className="accordion d-flex flex-column mt-3">
                    {!loading &&
                        Object.entries(sportsSideBarAll || {}).map(
                            ([cat, values], ind) => {
                                const items = values?.split(",").filter(Boolean);

                                return (
                                    <div className="accordion-item" key={cat}>
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button shadow-none bg-transparent border-0 ${openAccordionIndex === ind ? "" : "collapsed"
                                                    }`}
                                                type="button"
                                                onClick={() =>
                                                    setOpenAccordionIndex(prev =>
                                                        prev === ind ? null : ind
                                                    )
                                                }
                                            >
                                                {cat}
                                            </button>
                                        </h2>

                                        <div
                                            className={`accordion-collapse collapse ${openAccordionIndex === ind ? "show" : ""
                                                }`}
                                        >
                                            <div className="accordion-body pt-0">
                                                <ul className="custom-list">
                                                    {items.map((val, i) => (
                                                        <li key={i}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={
                                                                    normalize(selectedCheckbox) === normalize(val)
                                                                }
                                                                onChange={() => onChange(val)}
                                                            />
                                                            <span>{val}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        )}
                </div>
            </div>
        </div>
    );
}
